import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import axios from "axios";
import useAuth from "../../utils/useAuth";
import { useTranslation } from "react-i18next";
import { getToken } from "../../utils/auth";
import { Country } from "country-state-city";

const SponsoredHeader = () => {
  useAuth();
  const { t, i18n } = useTranslation();
  const [sponsoredAd, setSponsoredAd] = useState([]);
  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const countryCode = response?.data?.data?.country || "";
      const countryInfo = Country.getCountryByCode(countryCode);
      const countryName = countryInfo?.name || "";
      handleSponsored(countryName);

    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  const handleSponsored = async (adsCountry) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/ad/active/ads?country=${adsCountry}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSponsoredAd(response?.data?.data?.activeNavBarAds);

    } catch (error) {
      console.log("Failed Fetching Sponsored Ads", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleAdClick = async (adId, websiteLink) => {
    if (!websiteLink) return;

    try {
      const token = getToken();
      await axios.get(`${process.env.REACT_APP_URL}/api/ad/visit/${adId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log("Ad visit recorded successfully");
    } catch (error) {
      console.error("Failed to record ad visit:", error);
    }
    window.open(websiteLink, "_blank");
  };

  return (
    <>
      <ul className="suggested-page-story m-0 p-1 list-inline">
        <li className="">
          <Carousel
            showArrows={false}
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
            infiniteLoop
            autoPlay
            interval={2000}
          >
            {sponsoredAd?.map((image, index) => (
              <>
              {sponsoredAd?.websiteLink ? (
                  <div key={index} style={{ cursor: "pointer"}} onClick={() =>
                    handleAdClick(sponsoredAd._id, sponsoredAd.websiteLink)
                  }>
                  <img
                  src={image?.image}
                  className="img-fluid rounded"
                  alt="Sponsored Ad"
                  style={{ maxHeight: "50px" }}
                  />
                  </div>
                ) : (
                  <div key={index}>
                  <img
                    src={image?.image}
                    className="img-fluid rounded"
                    alt="Sponsored Ad"
                    style={{ maxHeight: "50px" }}
                  />
              </div>
                )}
                </>
            ))}
          </Carousel>
        </li>
      </ul>
    </>
  );
};

export default SponsoredHeader;
